import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Chip from '@material-ui/core/Chip'
import { formattedTimeWithTimezone } from 'utils/dateUtils'
import pluralize from 'lib/pluralize'
import ButtonCta from 'components/atoms/button-cta'
import { IconFlagFilled, IconPrice, IconCalendar } from 'components/atoms/icons'
import useStyles, { CardIcon } from './group-event-card.styles'
import { centsToDollarsFormatted } from 'lib/utils/number'

const GroupEventCard = ({ event }) => {
  const classes = useStyles()
  const history = useHistory()
  const {
    title,
    startDateTime,
    endDateTime,
    slug,
    maxAttendance,
    registrationCount,
    featuredImageUrl,
    priceInCents,
    sessions,
    coachFacility,
  } = event

  const timePeriod = formattedTimeWithTimezone(
    startDateTime,
    endDateTime,
    coachFacility?.timezone,
  )
  const priceInDollars = centsToDollarsFormatted(priceInCents)
  const remainingSpots = maxAttendance - registrationCount

  return (
    <Card
      className={`${classes.groupEvent}`}
      onClick={() => history.push(`/things-to-do/events/${slug}`)}
    >
      <CardMedia
        className={`${classes.media}`}
        image={featuredImageUrl && featuredImageUrl}
        title={title}
      />

      <CardIcon />
      {maxAttendance !== null && remainingSpots <= 5 && (
        <Chip className={classes.chip} label="Limited Availability" />
      )}
      <Box style={{ flexGrow: '1', display: 'flex', flexDirection: 'column' }}>
        <CardContent className={classes.cardContent}>
          <Box>
            {startDateTime && endDateTime && (
              <Typography variant="caption" className={classes.caption}>
                {timePeriod}
              </Typography>
            )}
            <Typography
              variant="h6"
              color="primary"
              className={classes.cardSubtitle}
            >
              {title}
            </Typography>
          </Box>
          <Box>
            {coachFacility != null && (
              <Box display="flex" mb={1}>
                <IconFlagFilled />
                <Typography
                  variant="caption"
                  className={classes.caption}
                  style={{ marginLeft: '12px' }}
                >
                  {coachFacility.name}
                </Typography>
              </Box>
            )}
            {sessions?.length > 0 && (
              <Box display="flex" mb={1}>
                <IconCalendar />
                <Typography
                  variant="caption"
                  className={classes.caption}
                  style={{ marginLeft: '12px' }}
                >
                  {sessions.length} {pluralize(sessions.length, 'session')}
                </Typography>
              </Box>
            )}
            {priceInCents != null && (
              <Box display="flex">
                <IconPrice />
                <Typography
                  variant="caption"
                  className={classes.caption}
                  style={{ marginLeft: '12px' }}
                >
                  {priceInDollars} / participant
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Box>
      <ButtonCta
        variant="text"
        arrow
        href={`/things-to-do/events/${slug}`}
        className={classes.ctaButton}
      >
        View Event
      </ButtonCta>
    </Card>
  )
}

GroupEventCard.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    featuredImageUrl: PropTypes.string,
    startDateTime: PropTypes.string,
    endDateTime: PropTypes.string,
    maxAttendance: PropTypes.number,
    slug: PropTypes.string,
    registrationCount: PropTypes.number,
    priceInCents: PropTypes.number,
    sessions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ),
    coachFacility: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      timezone: PropTypes.string,
    }),
  }).isRequired,
}

export default GroupEventCard
